/* ============================================================
   ORA — Préchargement de navigation
   Précharge les pages internes au survol (desktop) ou au premier
   contact tactile (mobile) pour une navigation quasi instantanée.
   Aucune dépendance. N'affecte que les liens internes.
   ============================================================ */
(function () {
  // Le navigateur doit supporter <link rel="prefetch">
  var test = document.createElement('link');
  if (!(test.relList && test.relList.supports && test.relList.supports('prefetch'))) {
    return;
  }

  // Respecte le mode économie de données / connexions lentes
  var conn = navigator.connection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) {
    return;
  }

  var done = {};
  var hoverTimer = null;

  function prefetch(url) {
    if (done[url]) return;
    done[url] = true;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
  }

  function cleanUrl(href) {
    return href.split('#')[0];
  }

  function eligible(a) {
    if (!a || !a.href) return false;
    if (a.origin !== location.origin) return false;          // liens internes uniquement
    if (a.hasAttribute('data-no-prefetch')) return false;
    if (a.getAttribute('target') === '_blank') return false;
    if (a.protocol !== 'http:' && a.protocol !== 'https:') return false;
    var path = a.pathname || '';
    // On évite les pages sensibles / dynamiques
    if (/^\/(cart|checkout|account)(\/|$)/.test(path)) return false;
    if (path.indexOf('/cart') === 0) return false;
    if (cleanUrl(a.href) === cleanUrl(location.href)) return false; // page courante
    return true;
  }

  // Desktop : on précharge après un court survol intentionnel
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest ? e.target.closest('a') : null;
    if (!eligible(a)) return;
    hoverTimer = setTimeout(function () {
      prefetch(cleanUrl(a.href));
    }, 60);
  });

  document.addEventListener('mouseout', function () {
    if (hoverTimer) {
      clearTimeout(hoverTimer);
      hoverTimer = null;
    }
  });

  // Mobile : on précharge dès le premier contact (avant même le relâchement)
  document.addEventListener('touchstart', function (e) {
    var a = e.target.closest ? e.target.closest('a') : null;
    if (!eligible(a)) return;
    prefetch(cleanUrl(a.href));
  }, { passive: true });
})();
